<template>
  <div class="standings-player-result-parts">
    <div class="standings-player-result-parts__data">
      <span class="standings-player-result-parts__value">
        <trophy-icon-parts
          v-if="totalPosition && totalPosition < 4"
          class="round-record-parts__position__icon"
          :position="totalPosition"
        />
        {{ displayTotalPosition }}
      </span>
      <span
        class="standings-player-result-parts__label"
        v-text="$tc('StandingsPage.DetailsPage.totalPosition')"
      />
    </div>
    <div class="standings-player-result-parts__data">
      <span class="standings-player-result-parts__value" v-text="totalPoints" />
      <span
        class="standings-player-result-parts__label"
        v-text="$tc('StandingsPage.TopPage.totalPts')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import TrophyIconParts from '@/components/StandingsPage/common/parts/TrophyIconParts.vue'

/**
 * Standings: 選手詳細 順位・ポイント表示パーツ
 */
export default defineComponent({
  name: 'StandingsPlayerResultParts',
  components: {
    TrophyIconParts,
  },
  props: {
    totalPosition: {
      type: Number,
      required: true,
    },
    totalPoints: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    /** 表示用の順位 */
    const displayTotalPosition = computed(() =>
      props.totalPosition ? String(props.totalPosition) : '---',
    )

    return {
      displayTotalPosition,
    }
  },
})
</script>

<style lang="scss" scoped>
.standings-player-result-parts {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;
  padding: 10px min(#{convertPXtoVW(20)}, 20px) 9px;
  border-top: 1px solid $black05;

  &__data {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-items: center;
    max-width: 380px;
    gap: 4px;
    height: 42px;
    text-align: center;
  }

  &__value {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    gap: min(#{convertPXtoVW(3)}, 3px);
    font-weight: 600;
    font-size: min(#{convertPXtoVW(18)}, 18px);
    line-height: 1.33;
    letter-spacing: 0.02em;
    color: $black;
  }

  &__label {
    font-weight: 500;
    font-size: min(#{convertPXtoVW(11)}, 11px);
    line-height: 1.27;
    letter-spacing: 0.04em;
    color: $gray50;
  }
}
</style>
